"use client";

import Link from "next/link";
import { useAuth } from "../lib/auth";

// Persistent top-of-page banner shown to lapsed-trial users across
// every surface they can reach. Aligned to Collin's design rules:
// - Every page renders; dead features surface this banner, not
//   errors or Oops pages.
// - One universal sales moment, not per-card mini-cards.
// - Quiet surface — banner is the one place upgrade lives.
//
// Returns null for non-lapsed users so pages wrapping it pay no
// cost when the user is paid/owner/guest/founder/BYOK.
export default function LapsedBanner() {
  const { isLapsed, profile } = useAuth();
  if (!isLapsed) return null;
  return (
    <div
      role="complementary"
      aria-label="Upgrade to keep Fülkit running"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "var(--space-3)",
        padding: "var(--space-3) var(--space-4)",
        background: "var(--color-bg-elevated)",
        border: "1px solid var(--color-border-light)",
        borderRadius: "var(--radius-md)",
        marginBottom: "var(--space-4)",
        fontFamily: "var(--font-primary)",
      }}
    >
      <div style={{ fontSize: "var(--font-size-sm)", color: "var(--color-text)", lineHeight: 1.5 }}>
        Everything's saved. The AI side's on pause —{" "}
        <span style={{ fontWeight: "var(--font-weight-medium)" }}>$9 flips it back on.</span>
      </div>
      <Link
        href="/settings/billing"
        style={{
          display: "inline-block",
          padding: "var(--space-2) var(--space-4)",
          background: "var(--color-text)",
          color: "var(--color-bg)",
          borderRadius: "var(--radius-sm)",
          fontSize: "var(--font-size-sm)",
          fontWeight: "var(--font-weight-medium)",
          textDecoration: "none",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        Upgrade
      </Link>
    </div>
  );
}
